export const GoCancelSearchDialogMessage = {
    modalTitle: 'Cancel Search',
    modalContent: 'Cancelled apps will not be saved for future use. Continue?',
    errorAlertMessage: 'An error occurred while cancelling the search.',
};
